var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-tag"},[_c('span',[_vm._v(_vm._s(_vm.displayName))]),_c('font-awesome-icon',{attrs:{"icon":"times"},on:{"click":function($event){return _vm.$emit('delete', _vm.tag)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }